var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_c('v-app-bar',{attrs:{"color":"primary"}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"title-right text--white"},[_vm._v(" "+_vm._s(_vm.titleRight)+" ")]),_c('v-spacer'),_vm._t("action")],2)],1),_c('v-card-text',{staticClass:"card-text"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }